<template>
  <div class="Axe__picture squarebox">
    <div style="display: flex; width: 100%;">
      <div class="Axe__picture__buttons">
        <div
          style="display: flex; flex-direction: column; align-items: flex-start"
        >
          <button class="button" :disabled="index === 0" @click="$emit('up')">
            <i class="icon fa fa-arrow-up"></i>
          </button>
          <button class="button is-danger" @click="$emit('delete')">
            <i class="icon fa fa-times"></i>
          </button>
          <button
            class="button"
            :disabled="index === total - 1"
            @click="$emit('down')"
          >
            <i class="icon fa fa-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="Axe__picture__picture" style="margin-right: 16px; margin-left: 10px;">
        <vertical-field>
          <picture-input
            :item="picture.picture_id"
            :label="'.jpg, RVB 300dpi'"
            :sublabel="'à dimensionner selon la charte.'"
            @gotpic="pic = $event"
            @update="updateKey('picture_id', $event.id)"
          ></picture-input>
          <div>
            <p v-if="pic && pic.authors && pic.authors.length > 0" class="is-size-7">© {{ pic.authors.map(({name}) => name).join(',') }}</p>
          </div>
        </vertical-field>
      </div>
      <div class="Axe__picture__caption">
        <div class="flex">
          <div style="width: 100%;">
            <horiz-field>
              <label for="" class="label" slot="label">Légende :</label>
              <input
                type="text"
                class="input"
                @input="updateKey('text', $event.target.value)"
                :value="picture.text"
              />
            </horiz-field>
            <div class="flex" style="">
              <div style="margin-right: 1em; flex-shrink: 0;">
                <horiz-field>
                  <label for="" class="label checkbox" slot="label"
                    >Est un plan ?</label
                  >
                  <input
                    type="checkbox"
                    class="checkbox"
                    @change="updateKey('plan', $event.target.checked)"
                    :checked="picture.plan"
                  />
                </horiz-field>
              </div>
              <div v-if="picture.plan" class="flex">
                <div style="margin-right: 1em;">
                  <horiz-field>
                    <label for="" class="label" slot="label">Échelle :</label>
                    <input
                      type="text"
                      class="input"
                      :value="picture.scale"
                      @input="updateKey('scale', $event.target.value)"
                    />
                  </horiz-field>
                </div>
                <div style="margin-right: 1em;">
                  <horiz-field>
                    <label for="" class="label" slot="label"
                      >Orientation :</label
                    >
                    <input
                      type="text"
                      class="input"
                      :value="picture.orientation"
                      @input="updateKey('orientation', $event.target.value)"
                    />
                  </horiz-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HorizField from "../../../components/Form/HorizField";
import PictureInput from "../../../components/Form/PictureInput";
import VerticalField from "../../../components/Form/VerticalField";
import { cheapoClone } from "../../../util/func";

export default {
  name: "axe-edit-picture",
  components: { HorizField, PictureInput, VerticalField },
  props: {
    index: {},
    total: {},
    picture: {}
  },
  data() {
    return {
      pic: null
    };
  },
  methods: {
    updateKey(key, val) {
      const p = cheapoClone(this.picture);
      p[key] = val;
      this.$emit("update", p);
    }
  }
};
</script>
